import React from 'react';
import PropTypes from 'prop-types';

// Day of week names for use in date-picker heading
const dayOfWeekNames = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];

export default class DaysOfWeek extends React.PureComponent {
    static propTypes = {
        styles: PropTypes.object,
    };

    render() {
        return (
            <div
                style={{
                    borderBottom: '.0625em solid #eaeaea',
                    marginBottom: '.25em',
                    ypaddingBottom: '.25em',
                    display: 'flex',
                    width: '100%',
                }}>
                {dayOfWeekNames.map((name, key) => <div
                    key={key}
                    style={{flexGrow: '1', justifyContent: 'space-between'}}>
                    {name}
                </div>)}
            </div>
        );
    }
}
